import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { webddn } from 'src/environments/webddn';

/** Restricts route to builds where APP_TYPE is assistant. */
@Injectable({ providedIn: 'root' })
export class AssistantAppGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (webddn.APP_TYPE === 'assistant') {
      return true;
    }
    this.router.navigate(['/unauthorized']);
    return false;
  }
}

/**
 * Modern Functional Route Guard for Angular 22
 */
export const assistantAppGuard: CanActivateFn = () => {
  return inject(AssistantAppGuard).canActivate();
};
